module.exports = __webpack_public_path__ + "static/img/cleanSuccess.b706d058.png";